/* ============
 * Account getters
 * ============
 *
 * The getters available for the account module.
 */

export default {};
